import label from './treemap.data.label'
import upperLabel from './treemap.data.upperLabel'
import itemStyle from './treemap.data.itemStyle'
import emphasis from './treemap.data.emphasis'
import tooltip from './treemap.data.tooltip'

export default {
  name: "data",
  nickname: "数据",
  desc:
    '<a target="__blank" href="https://echarts.apache.org/zh/option.html#series-treemap.data">series-treemap.data</a> 的数据格式是树状的，例如：',
  type: "array",
  props: {
    value: {
      name: "value",
      nickname: "值",
      desc:
        '每个树节点的值，对应到面积大小。可以是number，也可以是数组，如 <code class="codespan">[2323, 43, 55]</code>，则数组第一项对应到面积大小。',
      type: "pureValue",
    },
    name: {
      name: "name",
      nickname: "名称",
      desc: "显示在矩形中的描述文字。",
    },
    visualDimension: {
      name: "visualDimension",
      nickname: "视觉映射",
      desc:
        '<code class="codespan">treemap</code> 中支持对数据其他维度进行视觉映射。',
      value: 0,
      defaultValue: 0,
    },
    visualMin: {
      name: "visualMin",
      nickname: "当前层级的最小value值",
      desc: "当前层级的最小 value 值。如果不设置则自动统计。",
    },
    visualMax: {
      name: "visualMax",
      nickname: "当前层级的最大value值",
      desc: "当前层级的最大 value 值。如果不设置则自动统计。",
    },
    color: {
      name: "color",
      nickname: "颜色",
      desc:
        '表示同一层级的节点的 颜色 选取列表（选择规则见 <a target="__blank" href="https://echarts.apache.org/zh/option.html#series-treemap.colorMappingBy">colorMappingBy</a>）。默认为空时，选取系统color列表。',
      eType: "color",
    },
    colorAlpha: {
      name: "colorAlpha",
      nickname: "颜色透明度 ",
      desc: "表示同一层级的节点的 颜色透明度 选取范围。数值范围 0 ~ 1。",
    },
    colorSaturation: {
      name: "colorSaturation",
      nickname: "颜色饱和度",
      desc: "表示同一层级的节点的 颜色饱和度 选取范围。数值范围 0 ~ 1。",
    },
    colorMappingBy: {
      name: "colorMappingBy",
      nickname: "colorMappingBy",
      desc:
        '表示同一层级节点，在颜色列表中（参见 <code class="codespan">color</code> 属性）选择时，按照什么来选择。可选值：',
      value: "index",
      defaultValue: "index",
      type: "pureValue",
    },
    visibleMin: {
      name: "visibleMin",
      nickname: "visibleMin",
      desc:
        "如果某个节点的矩形的面积，小于这个数值（单位：px平方），这个节点就不显示。",
      value: 10,
      defaultValue: 10,
      type: "pureValue",
    },
    childrenVisibleMin: {
      name: "childrenVisibleMin",
      nickname: "childrenVisibleMin",
      desc:
        "如果某个节点的矩形面积，小于这个数值（单位：px平方），则不显示这个节点的子节点。",
    },
    label,
    upperLabel,
    itemStyle,
    emphasis,
    link: {
      name: "link",
      nickname: "链接",
      desc:
        '点击此节点可跳转的超链接。须 <a target="__blank" href="https://echarts.apache.org/zh/option.html#series-treemap.nodeClick">series-treemap.nodeClick</a> 值为 <code class="codespan">&#39;link&#39;</code> 时才生效。',
    },
    target: {
      name: "target",
      nickname: "目标类型",
      desc:
        '意义同 <code class="codespan">html</code> <code class="codespan">&lt;a&gt;</code> 标签中的 <code class="codespan">target</code>，参见 <a target="__blank" href="https://echarts.apache.org/zh/option.html#series-treemap.data.link">series-treemap.data.link</a>。可选值为：<code class="codespan">&#39;blank&#39;</code> 或 <code class="codespan">&#39;self&#39;</code>。',
      value: "blank",
      defaultValue: "blank",
      type: "pureValue",
    },
    children: {
      name: "children",
      nickname: "子节点列表",
      desc:
        '子节点，递归定义，格式同 <a target="__blank" href="https://echarts.apache.org/zh/option.html#series-treemap.data">series-treemap.data</a>。',
    },
    tooltip,
  },
}
